import type { PropsWithChildren } from 'react';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { ID } from '@/utils/enums';
import '@/components/header/components/content/content-v1.css';
import '@/components/header/components/content/content-v2.css';

export default function Content(props: PropsWithChildren) {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const { enableStickyMobileHead } = useAppSelector(ConfigSlice.selectors.header);
  const isLongReadShown = useAppSelector(GeneralSlice.selectors.isLongReadShown);

  return (
    <div
      id={ID.APP_HEADER}
      data-css-version={cssVersion}
      data-sticky-header={enableStickyMobileHead && isLongReadShown}
      className='header-content'
    >
      {props.children}
    </div>
  );
}
